import http from "helpers/APIHelper";
import { httpStatusEnum } from "appconstants";
import { map } from "rxjs/operators";
import { getSessionByKey } from "helpers";
import { suffixPending, suffixFulfilled, suffixRejected } from "actions";

export const PRT_DETAIL_ACTIONS = {
  GET_PROT_DETAILS: "@protocol/protocoldetail/getprotdetails",
  GET_PROT_STATUS_HIST: "@protocol/protocoldetail/getProtocolStatusHistory",
  SET_PROT_CONTACT: "@protocol/protocoldetail/setProtocolContact",
  SET_PROT_STATUS: "@protocol/protocoldetail/setProtStatus",
  GET_COHORTS: "@protocol/protocoldetail/getCohorts",
  GET_ARM_COHORTS: "@protocol/protocoldetail/getArmCohorts",
  GET_STRATA: "@protocol/protocoldetail/getStrata",
  GET_COHORT_HISTORY: "@protocol/protocoldetail/getCohortHistory",
  GET_STRATA_HISTORY: "@protocol/protocoldetail/getStrataHistory"
};

// ADDED APM Chnaged need to be deleted
export const getProtocolDetails = (token, loggerInfo, id) => (dispatch) => {
  dispatch({
    type: PRT_DETAIL_ACTIONS.GET_PROT_DETAILS + suffixPending
  });
  http
    .getWithToken(
      `protocol-data-service/${getSessionByKey(
        "prt_url_ver"
      )}/protocols/number/${id}/summary`,
      token,
      loggerInfo
    )
    .subscribe(
      (resp) => {
        dispatch({
          type: PRT_DETAIL_ACTIONS.GET_PROT_DETAILS + suffixFulfilled,
          payload: resp.response
        });
      },
      (error) => {
        dispatch({
          type: PRT_DETAIL_ACTIONS.GET_PROT_DETAILS + suffixRejected,
          payload: error
        });
      }
    );
};

export const getProtocolStatusHistory =
  (
    token,
    loggerInfo,
    id,
    postBody = { sort: [{ field: "effectiveDate", value: "desc" }] }
  ) =>
    (dispatch) => {
      dispatch({
        type: PRT_DETAIL_ACTIONS.GET_PROT_STATUS_HIST + suffixPending
      });
      http
        .getWithToken(
          `esys-data-service/${getSessionByKey(
            "esys_url_ver"
          )}/esys/object/PROTOCOL/workflow/${id}`,
          token,
          loggerInfo
        )
        .subscribe(
          (resp) => {
            dispatch({
              type: PRT_DETAIL_ACTIONS.GET_PROT_STATUS_HIST + suffixFulfilled,
              payload: resp.response
            });
          },
          (error) => {
            dispatch({
              type: PRT_DETAIL_ACTIONS.GET_PROT_STATUS_HIST + suffixRejected,
              payload: error
            });
          }
        );
    };

export const setProtocolContact =
  (token, loggerInfo, postBody, id) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/id/${id}/contact`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getProtocolDetails(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const setStatusChange =
  (token, loggerInfo, postBody, id) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/id/${id}/groupstatus`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getProtocolDetails(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const setPcdChange =
  (token, loggerInfo, postBody, id) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/id/${id}/completiondates`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getProtocolDetails(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const cancelRequest = (token, loggerInfo, id) => (dispatch, getState) =>
  http
    .deleteWithToken(
      `protocol-data-service/${getSessionByKey(
        "prt_url_ver"
      )}/protocols/id/${id}/groupstatus`,
      token,
      loggerInfo
    )
    .pipe(
      map((resp) => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          dispatch(
            getProtocolDetails(
              token,
              loggerInfo,
              getState().prtDetails.prtInfo.protocolNumber
            )
          );
        }
        return resp;
      })
    );

export const saveCollectIrbApproval =
  (token, loggerInfo, postBody, id) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/number/${id}/collectirbapproval`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getProtocolDetails(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const saveComments =
  (token, loggerInfo, postBody, id) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/id/${id}/comments`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getProtocolDetails(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const getCohortData = (token, loggerInfo, prtNum) => (dispatch) => {
  http
    .getWithToken(
      `protocol-data-service/${getSessionByKey(
        "prt_url_ver"
      )}/protocols/number/${prtNum}/cohorts`,
      token,
      loggerInfo
    )
    .subscribe(
      (res) => {
        dispatch({
          type: PRT_DETAIL_ACTIONS.GET_COHORTS + suffixFulfilled,
          payload: res.response
        });
      },
      (err) => {
        dispatch({ type: PRT_DETAIL_ACTIONS.GET_COHORTS + suffixPending });
      }
    );
};

export const getArmCohortData = (token, loggerInfo, prtNum) => (dispatch) => {
  http
    .getWithToken(
      `protocol-data-service/${getSessionByKey(
        "prt_url_ver"
      )}/protocols/number/${prtNum}/armcohorts`,
      token,
      loggerInfo
    )
    .subscribe(
      (res) => {
        dispatch({
          type: PRT_DETAIL_ACTIONS.GET_ARM_COHORTS + suffixFulfilled,
          payload: res.response
        });
      },
      (err) => {
        dispatch({ type: PRT_DETAIL_ACTIONS.GET_ARM_COHORTS + suffixPending });
      }
    );
};

export const saveCohortData =
  (token, loggerInfo, prtId, postBody) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/id/${prtId}/cohorts/${postBody.pmcId}`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getCohortData(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const saveCohortArmData =
  (token, loggerInfo, postBody) => (dispatch, getState) =>
    {
      return (
        http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/armcohorts`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getArmCohortData(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      )
    )
  };


export const saveStrataData =
  (token, loggerInfo, prtId, pmcId, postBody) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/id/${prtId}/cohorts/${pmcId}/stratums/${postBody.pmsId}`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getCohortData(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const saveArmsData =
  (token, loggerInfo, postBody) => (dispatch, getState) =>
    http
      .putWithToken(
        `protocol-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/protocols/arms`,
        token,
        loggerInfo,
        JSON.stringify(postBody)
      )
      .pipe(
        map((resp) => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            dispatch(
              getArmCohortData(
                token,
                loggerInfo,
                getState().prtDetails.prtInfo.protocolNumber
              )
            );
          }
          return resp;
        })
      );

export const getCohortsHistory =
  (token, loggerInfo, pmcId) => (dispatch, getState) =>
    http
      .getWithToken(
        `esys-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/esys/object/UPD_PROT_COHORT/workflow/${pmcId}`,
        token,
        loggerInfo
      )
      .subscribe(
        (resp) => {
          dispatch({
            type: PRT_DETAIL_ACTIONS.GET_COHORT_HISTORY + suffixFulfilled,
            payload: resp.response
          });
        },
        (err) => {
          dispatch({
            type: PRT_DETAIL_ACTIONS.GET_COHORT_HISTORY + suffixPending
          });
        }
      );

export const getStrataHistory =
  (token, loggerInfo, pmsId) => (dispatch, getState) =>
    http
      .getWithToken(
        `esys-data-service/${getSessionByKey(
          "prt_url_ver"
        )}/esys/object/UPDATE_PROT_STRATUM/workflow/${pmsId}`,
        token,
        loggerInfo
      )
      .subscribe(
        (resp) => {
          dispatch({
            type: PRT_DETAIL_ACTIONS.GET_STRATA_HISTORY + suffixFulfilled,
            payload: resp.response
          });
        },
        (err) => {
          dispatch({
            type: PRT_DETAIL_ACTIONS.GET_STRATA_HISTORY + suffixPending
          });
        }
      );

export const syncCohorts = (token, loggerInfo, number) => (dispatch, getState) =>
  http.putWithToken(
    `protocol-data-service/${getSessionByKey('prt_url_ver')
    }/protocols/number/${number}/cohorts/sync`,
    token,
    loggerInfo
  ).pipe(map(resp => resp));

export const matchBoxSave = (token, loggerInfo, prtId, flag, value) => (dispatch, getState) =>
  http.putWithToken(`protocol-data-service/${getSessionByKey('prt_url_ver')
    }/protocols/id/${prtId}/flags/${flag}/${value}`,
    token,
    loggerInfo).pipe(map(resp => resp));

export const getCirb = (token, loggerInfo, protocolNumber) => (dispatch, getState) => {
   return http
      .postWithToken(`protocol-data-service/${getSessionByKey('prt_url_ver')}/protocols/number/${protocolNumber}/approvals`,
        token,
        loggerInfo
      )
};
